
import type {
    TiassistoGetDriveItEasyStatusRequest,
    TiassistoDieStatusData,
    TiassistoPudLogsResponseDTO,
    TiassistoVehicleResponseDTO,
    TiassistoVehicleSaveRequestDTO,
    TiassistoAddBookingResponseDTO,
    TiassistoAddBookingRequestDTO,
    TiassistoDisableResponseDTO,
    TiassistoDisableRequestDTO,
    TiassistoActivePudResponseDTO,
    TiassistoDeletePudResponseDTO,
    TiassistoPudDetailsResponseDTO,
    TiassistoMaintenanceCategoriesReponseDTO,
    TiassistoMaintenanceSubCategoriesReponseDTO,
    TiassistoPudStatusesResponseDTO,
    TiassistoPudLogsRequestDTO
} from '../index';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class TiassistoControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) { }

    public createVehicleUser(requestDTO: TiassistoVehicleSaveRequestDTO): CancelablePromise<TiassistoVehicleResponseDTO> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/vehicles/tiassisto/createVehicle',
            body: requestDTO,
            mediaType: 'application/json',
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }

    public addBooking(requestDTO: TiassistoAddBookingRequestDTO): CancelablePromise<TiassistoAddBookingResponseDTO> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/vehicles/tiassisto/addBooking',
            body: requestDTO,
            mediaType: 'application/json',
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }

    // Deprecated
    public disableDriveItEasy(requestDTO: TiassistoDisableRequestDTO): CancelablePromise<TiassistoDisableResponseDTO> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/vehicles/tiassisto/disable-drive-it-easy',
            body: requestDTO,
            mediaType: 'application/json',
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }

    public updateDriveItEasy(requestDTO: TiassistoDisableRequestDTO): CancelablePromise<TiassistoDisableResponseDTO> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/vehicles/tiassisto/update-drive-it-easy',
            body: requestDTO,
            mediaType: 'application/json',
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }

    public getActivePud(licensePlate: string): CancelablePromise<TiassistoActivePudResponseDTO> {
        return this.httpRequest.request({
            method: 'GET',
            url: `/vehicles/tiassisto/pud/active/${licensePlate}`,
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }

    public deletePudRequest(pudId: string | number): CancelablePromise<TiassistoDeletePudResponseDTO> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: `/vehicles/tiassisto/pud/delete/${pudId}`,
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }

    public getPudDetails(pudId: string): CancelablePromise<TiassistoPudDetailsResponseDTO> {
        return this.httpRequest.request({
            method: 'GET',
            url: `/vehicles/tiassisto/pud/details/${pudId}`,
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }


    public getPudMaintenanceCategories(): CancelablePromise<TiassistoMaintenanceCategoriesReponseDTO> {
        return this.httpRequest.request({
            method: 'GET',
            url: `/vehicles/tiassisto/pud/maintenance/get-categories`,
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }

    public getPudMaintenanceSubCategories(categoryId: string): CancelablePromise<TiassistoMaintenanceSubCategoriesReponseDTO> {
        return this.httpRequest.request({
            method: 'GET',
            url: `/vehicles/tiassisto/pud/maintenance/get-sub-categories/${categoryId}`,
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }

    public getPudLogs(logsRequestDTO: TiassistoPudLogsRequestDTO): CancelablePromise<TiassistoPudLogsResponseDTO> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/vehicles/tiassisto/pud/logs',
            body: logsRequestDTO,
            mediaType: 'application/json',
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        })
    }

    public getPudsHistory(licensePlate: string): CancelablePromise<TiassistoPudDetailsResponseDTO> {
        return this.httpRequest.request({
            method: 'GET',
            url: `/vehicles/tiassisto/pud/history/${licensePlate}`,
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }

    public getPudByStatus(statusId: string): CancelablePromise<TiassistoPudDetailsResponseDTO> {
        return this.httpRequest.request({
            method: 'GET',
            url: `/vehicles/tiassisto/pud/status-elements/${statusId}`,
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });

    }
    public getPudStatuses(): CancelablePromise<TiassistoPudStatusesResponseDTO> {
        return this.httpRequest.request({
            method: 'GET',
            url: `/vehicles/tiassisto/pud/statuses`,
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }

    public getDriveItEasyStatus(driveItEasyStatusRequest: TiassistoGetDriveItEasyStatusRequest): CancelablePromise<TiassistoDieStatusData> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/vehicles/tiassisto/get-drive-it-easy-status',
            body: driveItEasyStatusRequest,
            mediaType: 'application/json',
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }
}
